import React from 'react'
import sunIcon from "../assets/icons/sun.png";
import moonIcon from "../assets/icons/moon.png";
import sunsetIcon from "../assets/icons/sunset.png";
import gridIcon from "../assets/icons/grid.png";
import backIcon from "../assets/icons/back.png";
import ButtonWithIcon from './ButtonWithIcon';
import buildingIcon from "../assets/icons/building.png";

export const presets = [
  {
    name: "Day",
    icon: sunIcon,
  },
  {
    name: "Night",
    icon: moonIcon,
  },
  {
    name: "Sunset",
    icon: sunsetIcon,
  },
  // {
  //   name: "Grid",
  //   icon: gridIcon,
  // },

  // {
  //   name: '360',
  //   icon: buildingIcon,
  // }
]
const Presets = ({
    animationEnded,
    isRtl,
    setPreset,
    environmentPreset,
    onBackButtonClick,
    showBackButton = false,
    showPresets = true,
    showGrid = false,
    setShowGrid,
    show360 = false,
    projectImages = []
}) => {
  const hasTourApartmentId = new URLSearchParams(window.location.search).has('tourApartmentId');
  // Only offer a lighting preset when the back-office has an actual image configured
  // for it; with none configured, the strip stays hidden rather than falling back
  // to the generic procedural-sky toggle.
  const configuredPresets = presets.filter((preset) =>
    projectImages.some((img) => img.name.toLowerCase() === preset.name.toLowerCase())
  );


      let style = {
        position: "fixed",
        top: 0,
        left: isRtl ? (animationEnded ? 0 : "-100rem") : "auto",
        right: isRtl ? "auto" : (animationEnded ? "0rem" : "-100rem"),
        zIndex: 10,
        width: "3rem",
        height: "100svh",
        backgroundColor: 'rgba(28, 28, 28, .6)',
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        // borderRadius: "1rem",
        transition: "all 0.5s",
      }
    return (
        <div
          className="enviroment"
          style={style}
        >
          <div className="top"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '7%',
          
              // visibility: showBackButton ? 'visible' : 'hidden'
            }}
            >
            {!hasTourApartmentId && (
              <ButtonWithIcon
                  width={'2rem'}
                  height={'2rem'}
                  icon={showBackButton ? backIcon : buildingIcon}
                  text={'Back'}
                  onClick={onBackButtonClick}
                  active={false}
                  />
            )}
          </div>
          <div className="center"
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: '1rem',
              alignItems: 'center',
              height: 'auto'
            }}>
            {showPresets && configuredPresets.map((option, i) => {
              return (
                <ButtonWithIcon 
                 
                  key={i} 
                  icon={option.icon} 
                  text={option.name} 
                  onClick={() => setPreset(option.name)} 
                  active={environmentPreset === option.name}
                  />
              );
            })}
            <ButtonWithIcon 
                 width={'1.5rem'}
                  height={'1.5rem'}
                icon={gridIcon} 
                text={'Grid'} 
                onClick={setShowGrid} 
                active={showGrid}
                style={{
                  border: showGrid ? '1px solid white' : 'none',
                }}
                />
          </div>
          <div className="bottom"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '10%',
              visibility: 'hidden'
            }}
            >
          {/* <ButtonWithIcon 
                
                icon={'exit'} 
                text={'Back'} 
                onClick={() => console.log('back')} 
                active={false}
                /> */}
          </div>
          {/* <Clouds scene={scene} /> */}
    
          
        </div>
      )
    }

export default Presets

